import Echo from 'laravel-echo'

window.URI = require('urijs')
window.axios = require('axios')
window._ = require('underscore')
window.moment = require('moment')
window.Promise = require('promise')
window.Cookies = require('js-cookie')
window.jQuery = window.$ = require('jquery')
window.Pusher = require('pusher-js')
window.Spark = Object.assign({}, window.SparkConfig)

require('bootstrap/js/collapse')
require('bootstrap/js/dropdown')
require('bootstrap/js/modal')
require('bootstrap/js/tab')
require('bootstrap/js/tooltip')
require('bootstrap/js/popover')

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: Spark.pusher_key,
    csrfToken: Spark.csrfToken,
    cluster: 'eu',
    encrypted: true,
    namespace: '',
})

// Load moment js languages
moment.locale('da', require('dashboard-js/lang/moment.da'))
moment.locale('da-short', require('dashboard-js/lang/moment.da-short'))
moment.locale('da')
